import type { IconSvgObject } from './types';

const AlphaSquareIcon: IconSvgObject = [
  ["path", { d: "M2.5 19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V4.50043C21.5 3.39589 20.6046 2.50046 19.5001 2.50043L4.50005 2.50005C3.39546 2.50002 2.5 3.39546 2.5 4.50005V19.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 8C15 11 13.8 16 10.8158 16C8.98453 16 7.5 14.2091 7.5 12C7.5 9.79086 8.98453 8 10.8158 8C15 8 13 16 15.5 16C16.0323 16 16.5 15.5556 16.5 15.1111", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default AlphaSquareIcon;
